import request from '@/utils/request'

// 登录方法
export function login(username, password, uuid) {
    return request({
        url: '/auth/login',
        method: 'post',
        data: { username, password, uuid }
    })
}

// 退出方法
export function logout() {
    return request({
        url: '/auth/logout',
        method: 'delete'
    })
}

// 注册方法
export function register(data) {
    return request({
        url: '/auth/register',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}

// 获取用户详细信息
export function getInfo() {
    return request({
        url: '/system/user/getInfo',
        method: 'get'
    })
}

// 企业微信授权地址
export function qywxOauthUrl(params) {
    return request({
        url: '/auth/qywxOauthUrl',
        method: 'get',
        params: params
    })
}

// 企业微信授权登录
export function qywxLogin(params) {
    return request({
        url: '/auth/qywxLogin',
        method: 'get',
        params: params
    })
}
